export default __webpack_public_path__ + "static/media/icon-idcard-scg.4847e24c.svg";